import { Typography } from '@mui/material';
import type { ColumnDef } from '../common/tableFeatures';
import { clipped, dateSortValue, dateTime, selectColumn } from '../common/tableCells';
import type { DfoGateway } from '@store/api/dfoRegistryApi';

const monoColumn = (
  key: 'device_mac' | 'vendor_serial' | 'secure_code' | 'secure_serial' | 'iot_hub_device_id',
  header: string,
  size: number
): ColumnDef<DfoGateway> => ({
  accessorKey: key,
  header,
  cell: ({ row }) => clipped(row.original[key], size - 20, { mono: true }),
  size,
});

const IDENTITY_COLUMNS: ColumnDef<DfoGateway>[] = [
  {
    id: 'name',
    accessorFn: (row) => row.name || '',
    header: 'Name',
    cell: ({ row }) => (
      <Typography variant="body2" noWrap sx={{ fontWeight: 500 }}>
        {row.original.name || '-'}
      </Typography>
    ),
    size: 200,
  },
  monoColumn('device_mac', 'MAC', 140),
  monoColumn('vendor_serial', 'Vendor Serial', 120),
  monoColumn('secure_code', 'Secure Code', 110),
  monoColumn('secure_serial', 'Secure Serial', 120),
  monoColumn('iot_hub_device_id', 'IoT Hub Device ID', 220),
];

/** Pending tab: selectable, with the last failed attempt. */
export const PENDING_COLUMNS: ColumnDef<DfoGateway>[] = [
  selectColumn<DfoGateway>((row) => row.name || row.device_mac, 'Select all gateways'),
  ...IDENTITY_COLUMNS,
  {
    id: 'dfo_registry_error',
    accessorFn: (row) => row.dfo_registry_error || '',
    header: 'Last Error',
    cell: ({ row }) => clipped(row.original.dfo_registry_error, 260, { error: true }),
    size: 280,
  },
];

/** Registered tab: read-only, with when and by whom. */
export const REGISTERED_COLUMNS: ColumnDef<DfoGateway>[] = [
  ...IDENTITY_COLUMNS,
  {
    id: 'dfo_registered_at',
    accessorFn: (row) => dateSortValue(row.dfo_registered_at),
    header: 'Registered At',
    cell: ({ row }) => dateTime(row.original.dfo_registered_at),
    size: 180,
  },
  {
    id: 'dfo_registered_by',
    accessorFn: (row) => row.dfo_registered_by || '',
    header: 'Registered By',
    cell: ({ row }) => row.original.dfo_registered_by || '-',
    size: 150,
  },
];
